
const vegetables = [
        {
          type:"veg",
          key: 1,
          name: "BEETROOT",
          price: "₹  7 / 250 g",
          weight: 250,
          src: require("./beetroot.webp"),
          priceint: 7
        },
        {
          type:"veg",
          key: 2,
          name: "BRINJAL",
          price: "₹  27 / 500 g",
          weight: 500,
          src: require("./brinjal.webp"),
          priceint: 30
        },
        {
          type:"veg",
          key: 3,
          name: "CABBAGE",
          price: "₹  16 / 500 g",
          weight: 500,
          src: require("./cabbage.webp"),
          priceint: 16
        },
        {
          type:"veg",
          key: 4,
          name: "CAPSICUM",
          price: "₹  28 / 500 g",
          weight: 500,
          src: require("./capsicum.webp"),
          priceint: 28
        },
        {
          type:"veg",
          key: 5,
          name: "CARROT",
          price: "₹  24 / 500 g",
          weight: 500,
          src: require("./carrot.webp"),
          priceint: 24
        },
        {
          type:"veg",
          key: 6,
          name: "CAULIFLOWER",
          price: "₹  40 / 500 g",
          weight: 500,
          src: require("./cauliflower.webp"),
          priceint: 40
        },
        {
          type:"veg",
          key: 7,
          name: "CORIANDER",
          price: "₹  24 / 250 g",
          weight: 250,
          src: require("./coriander.webp"),
          priceint: 24
        },
        {
          type:"veg",
          key: 8,
          name: "CUCUMBER",
          price: "₹  10 / 500 g",
          weight: 500,
          src: require("./cucumber.webp"),
          priceint: 10
        },
        {
          type:"veg",
          key: 9,
          name: "DRUM STICKS",
          price: "₹  12 / 250 g",
          weight: 250,
          src: require("./drum sticks.webp"),
          priceint: 12
        },
        {
          type:"veg",
          key: 10,
          name: "GINGER",
          price: "₹  25 / 250 g",
          weight: 250,
          src: require("./ginger.webp"),
          priceint: 25
        },
        {
          type:"veg",
          key: 11,
          name: "GREEN CHILLIES",
          price: "₹  20 / 250 g",
          weight: 250,
          src: require("./green chillies.webp"),
          priceint: 20
        },
        {
          type:"veg",
          key: 12,
          name: "MUSHROOMS",
          price: "₹  48 / 200 g",
          weight: 200,
          src: require("./mushrooms.webp"),
          priceint: 48
        },
        {
          type:"veg",
          key: 13,
          name: "ONION",
          price: "₹  21 / 1000 g",
          weight: 1000,
          src: require("./onion.webp"),
          priceint: 21
        },
        {
          type:"veg",
          key: 14,
          name: "POTATO",
          price: "₹  22 / 1000 g",
          weight: 1000,
          src: require("./potato.webp"),
          priceint: 22
        },
        {
          type:"veg",
        key: 15,
        name: "RIDGE GOURD",
        price: "₹  25 / 500 g",
        weight: 500,
        src: require("./ridge gourd.webp"),
        priceint: 25
        },
        {
          type:"veg",
        key: 17,
        name: "SPINACH",
        price: "₹  27 / 300 g",
        weight: 300,
        src: require("./spinach.webp"),
        priceint: 27
        },
        {
          type:"veg",
        key: 18,
        name: "TOMATO",
        price: "₹  15 / 1000 g",
        weight: 1000,
        src: require("./tomato.webp"),
        priceint: 15
        },
        {
          type:"veg",
          key: 19,
          "name": "Sweet Corn",
          "weight": "2 pcs (Approx. 500g - 600g)",
          "price": "₹ 40 / 2 pcs ( 500g - 600g )",
          "priceint": 40,
          "src": require("./Sweet Corn.webp")
          },
          {
          type:"veg",
          key: 20,
          "name": "Bottle Gourd",
          "weight": "1 pc (Approx. 450g - 800g)",
          "price": "₹ 24 / 1 pc ( 450g - 800g )",
          "priceint": 24,
          "src": require("./Bottle Gourd.webp")
          },
          {
          type:"veg",
          key: 21,
          "name": "Carrot Local",
          "weight": "500 g",
          "price": "₹ 34 / 500 g",
          "priceint": 34,
          "src": require("./Carrot Local.webp")
          },
          {
            type:"veg",
            key: 22,  
          "name": "Beans French",
          "weight": "250 g",
          "price": "₹ 49 / 250 g",
          "priceint": 49,
          "src": require("./Beans French.webp")
          },
          {
            type:"veg",
            key: 23, 
          "name": "Tomato Hybrid",
          "weight": "1 kg",
          "price": "₹ 29 / 1 kg",
          "priceint": 29,
          "src": require("./Tomato Hybrid.webp")
          },
          {
          type:"veg",
          key: 24,
          "name": "Garlic",
          "weight": "200 g",
          "price": "₹ 38 / 200 g",
          "priceint": 38,
          "src": require("./Garlic.jpg"),
          },
          {
            type:"veg",
            key: 25, 
          "name": "Beetroot",
          "weight": "250 g",
          "price": "₹ 16 / 250 g",
          "priceint": 16,
          "src": require("./beetroot.webp"),
          },
          {
            type:"veg",
            key: 26, 
          "name": "Mint Leaves",
          "weight": "100 g",
          "price": "₹ 13 / 100 g",
          "priceint": 13,
          "src": require("./Mint Leaves.webp"),
          },
          {
            type:"veg",
            key: 27, 
          "name": "Onion",
          "weight": "1 kg",
          "price": "₹ 25 / 1000 g",
          "priceint": 25,
          "src": require("./onion.webp"),
          },
          {
            type:"veg",
            key: 28, 
          "name": "Coriander Leaves (100gms), Lemon (200gms) & Chilli Green (100gms) Combo",
          "weight": "3 Combo",
          "price": "₹ 87 / 3 Combo",
          "priceint": 87,
          "src": require("./Coriander Leaves , Lemon  & Chilli Green  Combo.webp"),
          },
          {
            type:"veg",
            key: 29,  
          "name": "Cabbage",
          "weight": "1 pc (Approx. 600g)",
          "price": "₹ 24 / 1 pc ( 600g )",
          "priceint": 24,
          "src": require("./cabbage.webp"),
          },
          {
            type:"veg",
            key: 30, 
          "name": "Radish White",
          "weight": "500 g",
          "price": "₹ 26 / 500 g",
          "priceint": 26,
          "src": require("./Radish White.webp"),
          }
];

export default vegetables;
